import {
  statisticsPerson,
  statisticsPersonMonth,
  statisticsPersonQuarter,
  statisticsPersonYear,
  statisticsGroup,
  statisticsGroupMonth,
  statisticsGroupQuarter,
  statisticsGroupYear
} from '@/api/developreportserv'

export default {
  state: {
    state_DevelopReport_StatisticsPersonResult: null,
    state_DevelopReport_StatisticsPersonMonthResult: null,
    state_DevelopReport_StatisticsPersonQuarterResult: null,
    state_DevelopReport_StatisticsPersonYearResult: null,
    state_DevelopReport_StatisticsGroupResult: null,
    state_DevelopReport_StatisticsGroupMonthResult: null,
    state_DevelopReport_StatisticsGroupQuarterResult: null,
    state_DevelopReport_StatisticsGroupYearResult: null
  },
  mutations: {
    SET_DEVELOPREPORT_STATISTICSPERSON_RESULT: (state, rst) => {
      state.state_DevelopReport_StatisticsPersonResult = rst
    },
    SET_DEVELOPREPORT_STATISTICSPERSONMONTH_RESULT: (state, rst) => {
      state.state_DevelopReport_StatisticsPersonMonthResult = rst
    },
    SET_DEVELOPREPORT_STATISTICSPERSONQUARTER_RESULT: (state, rst) => {
      state.state_DevelopReport_StatisticsPersonQuarterResult = rst
    },
    SET_DEVELOPREPORT_STATISTICSPERSONYEAR_RESULT: (state, rst) => {
      state.state_DevelopReport_StatisticsPersonYearResult = rst
    },
    SET_DEVELOPREPORT_STATISTICSGROUP_RESULT: (state, rst) => {
      state.state_DevelopReport_StatisticsGroupResult = rst
    },
    SET_DEVELOPREPORT_STATISTICSGROUPMONTH_RESULT: (state, rst) => {
      state.state_DevelopReport_StatisticsGroupMonthResult = rst
    },
    SET_DEVELOPREPORT_STATISTICSGROUPQUARTER_RESULT: (state, rst) => {
      state.state_DevelopReport_StatisticsGroupQuarterResult = rst
    },
    SET_DEVELOPREPORT_STATISTICSGROUPYEAR_RESULT: (state, rst) => {
      state.state_DevelopReport_StatisticsGroupYearResult = rst
    }
  },
  actions: {
    DevelopReportServ_StatisticsPerson ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsPerson(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_DEVELOPREPORT_STATISTICSPERSON_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_DEVELOPREPORT_STATISTICSPERSON_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    DevelopReportServ_StatisticsPersonMonth ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsPersonMonth(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_DEVELOPREPORT_STATISTICSPERSONMONTH_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_DEVELOPREPORT_STATISTICSPERSONMONTH_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    DevelopReportServ_StatisticsPersonQuarter ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsPersonQuarter(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_DEVELOPREPORT_STATISTICSPERSONQUARTER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_DEVELOPREPORT_STATISTICSPERSONQUARTER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    DevelopReportServ_StatisticsPersonYear ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsPersonYear(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_DEVELOPREPORT_STATISTICSPERSONYEAR_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_DEVELOPREPORT_STATISTICSPERSONYEAR_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    DevelopReportServ_StatisticsGroup ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsGroup(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_DEVELOPREPORT_STATISTICSGROUP_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_DEVELOPREPORT_STATISTICSGROUP_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    DevelopReportServ_StatisticsGroupMonth ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsGroupMonth(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_DEVELOPREPORT_STATISTICSGROUPMONTH_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_DEVELOPREPORT_STATISTICSGROUPMONTH_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    DevelopReportServ_StatisticsGroupQuarter ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsGroupQuarter(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_DEVELOPREPORT_STATISTICSGROUPQUARTER_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_DEVELOPREPORT_STATISTICSGROUPQUARTER_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    DevelopReportServ_StatisticsGroupYear ({ commit }, { params, urlparams, extfunc }) {
      return new Promise((resolve, reject) => {
        statisticsGroupYear(params, urlparams).then(response => {
          const rsp = response.data
          if (rsp.code === 200) {
            commit('SET_DEVELOPREPORT_STATISTICSGROUPYEAR_RESULT', rsp.data)
            if (extfunc !== null && extfunc !== undefined) {
              extfunc(commit, params, urlparams)
            }
            resolve(rsp)
          } else {
            commit('SET_DEVELOPREPORT_STATISTICSGROUPYEAR_RESULT', rsp)
            reject(rsp.msg)
          }
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
  getters: {
    get_DevelopReport_StatisticsPersonResult: state => {
      return state.state_DevelopReport_StatisticsPersonResult
    },
    get_DevelopReport_StatisticsPersonMonthResult: state => {
      return state.state_DevelopReport_StatisticsPersonMonthResult
    },
    get_DevelopReport_StatisticsPersonQuarterResult: state => {
      return state.state_DevelopReport_StatisticsPersonQuarterResult
    },
    get_DevelopReport_StatisticsPersonYearResult: state => {
      return state.state_DevelopReport_StatisticsPersonYearResult
    },
    get_DevelopReport_StatisticsGroupResult: state => {
      return state.state_DevelopReport_StatisticsGroupResult
    },
    get_DevelopReport_StatisticsGroupMonthResult: state => {
      return state.state_DevelopReport_StatisticsGroupMonthResult
    },
    get_DevelopReport_StatisticsGroupQuarterResult: state => {
      return state.state_DevelopReport_StatisticsGroupQuarterResult
    },
    get_DevelopReport_StatisticsGroupYearResult: state => {
      return state.state_DevelopReport_StatisticsGroupYearResult
    }
  }
}
